import { PlusOutlined } from "@ant-design/icons";
import { Modal, Upload } from "antd";
import { UploadFile } from "antd/lib/upload/interface";
import React, { useEffect, useState } from "react";
import { Media } from "types/media";
import { getToken } from "utils/auth";
import { $url } from "utils/url";

interface MultiImageUploadProps {
  uploadUrl?: string;
  onUploadOk: (fileList: Array<string>) => void;
  fileListProp: UploadFile<any>[];
}

export const MultiImageUpload = ({
  uploadUrl = import.meta.env.VITE_API_URL + "/v1/shop/product/upload",
  fileListProp,
  onUploadOk,
}: MultiImageUploadProps) => {
  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");
  const [previewTitle, setPreviewTitle] = useState("");
  const [fileList, setFileList] = useState<UploadFile<any>[]>();

  const handleChange = ({ fileList }: { fileList: UploadFile<any>[] }) => {
    setFileList(fileList);
    console.log("filelist", fileList);
    const filePathList = fileList.map((file) => {
      return $url(file.response?.data?.path || file.url);
    });

    onUploadOk(filePathList);
  };

  useEffect(() => {
    setFileList(() => fileListProp.map((e) => ({ ...e })));
  }, [fileListProp]);

  const uploadButton = (
    <div>
      <PlusOutlined />
      <div style={{ marginTop: 8 }}>Upload</div>
    </div>
  );

  const handlePreview = (e: UploadFile<any>) => {
    console.log("e", e);
    const imageUrl =
      e.url || import.meta.env.VITE_API_URL + e.response.data.path;
    setPreviewImage(imageUrl);
    setPreviewVisible(true);
  };

  return (
    <>
      <Upload
        headers={{ token: getToken() || "" }}
        action={uploadUrl}
        listType="picture-card"
        fileList={fileList}
        onPreview={(file) => handlePreview(file)}
        onChange={handleChange}
      >
        {fileList && fileList.length >= 8 ? null : uploadButton}
      </Upload>
      <Modal
        open={previewVisible}
        footer={null}
        onCancel={() => setPreviewVisible(false)}
      >
        <img alt="example" style={{ width: "100%" }} src={previewImage} />
      </Modal>
    </>
  );
};
